import styled from '@emotion/styled';
import { mapStylesProp } from 'utils/styles';

export const Form = styled('form')(mapStylesProp);
